import React, { useState } from "react";
import { Modal, Image } from "react-bootstrap";
import translateWallet from "../translateWallet";
import CopyIcon from "../icons/copy_clippboard.svg";
import SpeiImage from "../../../Images/SPEI.png";

const STPModal = ({ show, close, language, clabe }) => {
  const [coppied, setCoppied] = useState(false);

  const handleCopy = async () => {
    if ("clipboard" in navigator) {
      setCoppied(true);
      return await navigator.clipboard.writeText(clabe);
    } else {
      let textArea = document.createElement("textarea");
      textArea.value = clabe;

      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      setCoppied(true);

      return new Promise((res, rej) => {
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  return (
    <Modal onHide={() => close()} show={show}>
      <div
        style={{
          padding: 64,
          overflow: "scroll",
          backgroundColor: "#F5F5F5",
        }}
      >
        <div className="STPModal_container">
          <h2
            className="STPModal_container_header"
            style={{ fontWeight: "500" }}
          >
            {translateWallet[language].STPModal.title}
          </h2>
          <Image src={SpeiImage} className="STPModal_SPEI_img" />
          <p className="STPModal_container_description">
            {translateWallet[language].STPModal.description}
          </p>

          <p className="STPModal_container_title">
            {translateWallet[language].STPModal.destinyTitle}
          </p>
          <p className="STPModal_container_text">
            {translateWallet[language].STPModal.destinyText}
          </p>

          <div className="STPModal_container_divider" />

          <p className="STPModal_container_title">
            {translateWallet[language].STPModal.clabeTitle}
          </p>

          <div
            style={{
              alignItems: "flex-start",
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div onClick={handleCopy} className="STPModal__clabe_container">
              {clabe}
              <Image
                src={CopyIcon}
                className="STPModal__clabe_container__image"
              />
            </div>
          </div>
          <small style={{ color: "#222E58", minHeight: 19.2, marginBottom: 2 }}>
            {coppied ? translateWallet[language].STPModal.coppied : ""}
          </small>

          <div className="STPModal_container_divider" />

          <p className="STPModal_container_title">
            {translateWallet[language].STPModal.holderTitle}
          </p>
          <p className="STPModal_container_text">
            {`${localStorage.getItem("user_name")} ${localStorage.getItem(
              "user_first_last_name"
            )} ${localStorage.getItem("user_second_last_name")}`}
          </p>

          <small style={{ color: "#797878", fontSize: 14, marginTop: 16 }}>
            {translateWallet[language].STPModal.warning}
          </small>
        </div>
        <button
          className="STPModal__button"
          onClick={() => {
            close();
            setCoppied(false);
          }}
        >
          Regresar
        </button>
      </div>
    </Modal>
  );
};

export default STPModal;
